import styled from 'styled-components';
import {FlexCol} from '@quarks';
import {StyledMapViewProps} from './types';
import {BREAKPOINTS} from '@constants';

export const StyledMapView = styled(FlexCol)<StyledMapViewProps>`
  position: relative;
  height: ${({$fullView}) => ($fullView ? '100%' : '300px')};
  width: 100%;
  border-radius: ${({$borderRadius}) => $borderRadius && `${$borderRadius}px`};
  overflow: hidden;

  * {
    pointer-events: ${({$disablePointerEvents}) => $disablePointerEvents && 'none !important'};
  }

  background: ${({$hasError, theme}) => ($hasError ? theme.card.red.background : 'transparent')};

  ${BREAKPOINTS.small`
    height: ${({$fullView}) => ($fullView ? '100%' : '200px')}
  `}
`;
